<template>
  <div class="windBodyBox">
    <div id="windMap"></div>
    <div class="uploadBox">
      <div class="unpTitle">导入数据</div>
      <el-button type="primary" style="margin-top:20px" @click="uploadDataHandel"  size="mini">上传文件</el-button>
       <!-- <el-select style="margin-top:15px"   @change="timeChange" v-model="chooseIndex" size="mini" placeholder="请选择">
    <el-option
      v-for="item in options"
    
      :key="item.label"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->
    </div>
    <el-dialog title="提示" :visible.sync="isShowupLoadBox" width="30%">
      <el-upload
        class="upload-demo"
        drag
        action
        :on-change="handleChange"
        :auto-upload="false"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip"></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowupLoadBox = false">取 消</el-button>
        <el-button type="primary" @click="isShowupLoadBox = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../map/mapImport.js";
import mydata from "../map/wind.json";
import datajson from "../assets/wind.json";
import moment from "moment";
import velocityLayer from "leaflet-velocity/dist/leaflet-velocity";
export default {
  data() {
    return {
      map: null,
      windUdata: [],
      windVdata: [],
      velocityLayer: null,
      tilePixelLayer: null,
      isShowupLoadBox: false,
      uploadData: [],
    //   chooseIndex:0,
       options: [],
       boxLayer:null,
    };
  },
   beforeDestroy(){
    this.map.map.remove()
  },
  mounted() {
    this.map = new MapCreate();
    this.map.init("windMap");
  },
  methods: {
    showBoxTomap(data){
        var bounds = data;

// 创建一个橙色的矩形
this.boxLayer= L.rectangle(bounds, {color: "black", weight: 2,fillOpacity:0,opacity:0}).addTo(this.map.map);

// 将地图放大到矩形的边界上
this.map.map.fitBounds(bounds);
    },
    timeChange(){
        this.boxLayer.removeFrom(this.map.map)
         if (this.velocityLayer) {
        this.map.map.removeLayer(this.velocityLayer);
        this.velocityLayer = null;
      }
         if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
      }
      this.showMydata();
    },
    uploadDataHandel() {
        
      if (this.velocityLayer) {
        this.map.map.removeLayer(this.velocityLayer);
        this.velocityLayer = null;
      }
      if (this.tilePixelLayer) {
        this.map.map.removeLayer(this.tilePixelLayer);
        this.tilePixelLayer = null;
        this.boxLayer.removeFrom(this.map.map)
      }
      this.isShowupLoadBox = true;
    },
    handleChange(file) {
      let reader = new FileReader();
      reader.readAsText(file.raw);
      reader.onload = e => {
        //console.log(e.target.result);
        // this.uploadData = [];
        this.uploadData = JSON.parse(e.target.result);
        //console.log(this.uploadData);
        this.isShowupLoadBox = false;
        
        this.showMydata();
      };
    },
    showGridData(data) {
      //console.log(data);
      this.tilePixelLayer = L.tilePixelLayer({
        newData: data.datas,
        data:data,
        gradient: legendColor["wind_s"],
        overlayAlpha: 100,
        clickEvt: function(e, gridValue) {
          ////console.log(e, gridValue);
          let popup = L.popup()
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(`<div>数值:${gridValue.toFixed(2)}</div>`)
            .openOn(t.map.map);
        }
      });
      ////console.log(this.ledgonList);
      this.map.map.addLayer(this.tilePixelLayer);
    },
    // uploadDataHandel() {},
    showMydata() {
      let arrdata = this.uploadData.dataList;
      //console.log(mydata);
      this.windUdata = arrdata.filter(function(value) {
        return value.element == "U10";
      });
      this.windVdata = arrdata.filter(function(value) {
        return value.element == "V10";
      });
      //console.log(this.windUdata, this.windVdata);
        // this.windVdata.map((item,index)=>{
        //     this.options.push({
        //           value:Number(index) ,
        //   label: item.fTime
        //     })
        // })
      // return

      datajson[0].header.numberPoints = this.windUdata[0].length;
      datajson[1].header.numberPoints = this.windUdata[0].length;

      datajson[0].header.nx = this.windUdata[0].cols;
      // datajson[0].header.nx = 410;
      datajson[0].header.ny = this.windUdata[0].rows;
      datajson[0].header.la1 = this.windUdata[0].top;
      datajson[0].header.la2 = this.windUdata[0].bottom;
      datajson[0].header.lo1 = this.windUdata[0].left;
      datajson[0].header.lo2 = this.windUdata[0].right;
      // datajson[0].header.dy = (geidData.top - geidData.bottom) / geidData.rows;
      // datajson[0].header.dx = (geidData.right - geidData.left) / geidData.cols;
      datajson[0].header.dy = (this.windUdata[0].top-this.windUdata[0].bottom)/this.windUdata[0].rows;
      datajson[0].header.dx = (this.windUdata[0].right-this.windUdata[0].left)/this.windUdata[0].cols;

      datajson[1].header.nx = this.windVdata[0].cols;
      // datajson[0].header.nx = 410;
      datajson[1].header.ny = this.windVdata[0].rows;
      datajson[1].header.la1 = this.windVdata[0].top;
      datajson[1].header.la2 = this.windVdata[0].bottom;
      datajson[1].header.lo1 = this.windVdata[0].left;
      datajson[1].header.lo2 = this.windVdata[0].right;
      datajson[1].header.dy = (this.windUdata[0].top-this.windUdata[0].bottom)/this.windUdata[0].rows;
      datajson[1].header.dx =  (this.windUdata[0].right-this.windUdata[0].left)/this.windUdata[0].cols;
      //  datajson[0].data =
      // //console.log();
      let vdata = this.windVdata[0].datas.split(",");
      let vdta2 = [];
      vdata.map(el => {
        vdta2.push(Number(el));
      });
      let udata = this.windUdata[0].datas.split(",");
      let udata2 = [];
      udata.map(el => {
        udata2.push(Number(el));
      });

      //console.log(udata2);
      //console.log(vdta2);
      datajson[0].data = udata2;
      datajson[1].data = vdta2;
      let speedData=[]
      vdta2.map((item,index)=>{
    let spdat =  Math.sqrt((  Math.pow(item, 2)+Math.pow(udata2[index], 2)))
     speedData.push(spdat)
      })
      let mtgridData = this.windVdata[0];
      mtgridData.datas = speedData;
      //console.log(speedData);
      this.showGridData(mtgridData);
      this.showBoxTomap([[this.windUdata[0].top,this.windUdata[0].left],[this.windUdata[0].bottom,this.windUdata[0].right]])
      let windColorList = [
        "rgb(255, 0, 13)",
        "rgb(255, 85, 0)",
        "rgb(255, 196, 0)"
      ];
      let linewidthData = 0.01;
      this.velocityLayer = L.velocityLayer({
        displayValues: false, //是否显示当前鼠标移动位置，风场信息
        displayOptions: {
          //显示信息配置
          velocityType: "Global Wind",
          displayPosition: "bottomleft",
          displayEmptyString: "No wind data"
        },
        data: datajson, //数据  格式可参照
        maxVelocity: 5,
        minVelocity: 0,
        velocityScale: linewidthData,
        particleMultiplier: 1 / 100,
        lineWidth: 2,
        colorScale: windColorList
      });
      this.map.map.addLayer(this.velocityLayer);
    }
  }
};
</script>

<style>
.windBodyBox {
  width: 100%;
  height: calc(100vh - 60px);
  background-color: aquamarine;
  position: relative;
}
#windMap {
  width: 100%;
  height: 100%;
}
.uploadBox {
  width: 150px;
  height: 100px;
  position: absolute;
  top: 50px;
  right: 25px;
  background-color: white;
  z-index: 999;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.unpTitle {
  height: 30px;
  width: 100%;
  line-height: 30px;
   font-size: 14px;
  text-align: center;
}
</style>